import { render, staticRenderFns } from "./SenseView.vue?vue&type=template&id=2d5c4e27"
import script from "./SenseView.vue?vue&type=script&lang=js"
export * from "./SenseView.vue?vue&type=script&lang=js"
import style0 from "./SenseView.vue?vue&type=style&index=0&id=2d5c4e27&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports